// 标签 type=2

import mixin from './mixin'

export default {
  mixins: [mixin],

  methods: {
    onCategoriesClick (item) {
      this.onClick(item)
    }
  },

  render () {
    const {
      list, // from mixin
      onCategoriesClick, // from this.methods
      style // from mixin
    } = this

    return (
      <section class={style.categories}>
        {
          list.map(item => {
            return (
              <div class={style.categoriesItem} onClick={() => onCategoriesClick(item)}>
                <img class='img-f' src={item.imageUrl} alt={item.title} />
              </div>
            )
          })
        }
      </section>
    )
  }
}
